import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { FormValidationMessagesComponent } from "./form-validation-messages.component";

@NgModule({
  declarations: [FormValidationMessagesComponent],
  exports: [FormValidationMessagesComponent],
  imports: [CommonModule, ReactiveFormsModule],
})
export class FormValidationMessageModule {}
